module.exports = __webpack_public_path__ + "static/img/usinessPartner_04_m.8c24c16e.jpg";